import { render, staticRenderFns } from "./RedpacketCountdown.vue?vue&type=template&id=d3086018&scoped=true&"
import script from "./RedpacketCountdown.vue?vue&type=script&lang=js&"
export * from "./RedpacketCountdown.vue?vue&type=script&lang=js&"
import style0 from "./RedpacketCountdown.vue?vue&type=style&index=0&id=d3086018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3086018",
  null
  
)

export default component.exports